import { ReactComponent as DownloadIcon } from "images/download-banner/download.svg";

const BANNER_IMG = "https://static.bigbrain.gg/assets/ugg/pages/desktop-app/aram-mayhem-download-app-banner.webp";

interface AramMayhemDownloadAppBannerProps {
  downloadHref?: string;
}

export function AramMayhemDownloadAppBanner({
  downloadHref = "/app?utm_source=UGG&utm_campaign=AramMayhemBuildPage",
}: AramMayhemDownloadAppBannerProps) {
  return (
    <div className="hidden md:block relative w-full max-w-[1016px] aspect-[1016/60] overflow-hidden rounded-[3px] isolate">
      <img src={BANNER_IMG} alt="" className="absolute inset-0 w-full h-full object-cover pointer-events-none z-[1]" />
      <div className="absolute left-[1.97%] top-1/2 -translate-y-1/2 z-[2] font-inter text-[20px] leading-[1.2] text-white whitespace-nowrap pointer-events-none">
        <strong>ARAM: Mayhem</strong>
        {" Augment Tiers Directly In Game"}
      </div>
      <a
        href={downloadHref}
        className="absolute right-[1.18%] top-1/2 -translate-y-1/2 z-[2] flex items-center justify-center gap-[6px] px-[12px] w-[14.17%] h-[56.67%] bg-[#FF4655] hover:bg-[#ff3a3d] rounded-[3px] no-underline transition-all duration-150 [filter:drop-shadow(0_4px_8px_rgba(0,0,0,0.4))]"
      >
        <DownloadIcon className="shrink-0 w-5 h-5" />
        <span className="font-inter font-semibold text-[13px] text-white whitespace-nowrap">Download App</span>
      </a>
      <div
        className="absolute bottom-0 left-0 right-0 h-[1px] z-[2]"
        style={{
          background: "linear-gradient(90deg, #C3F7C7 0%, #F5CF59 34.13%, #B9F5E3 56.25%, #8062F0 76.92%, #D585F3 100%)",
        }}
      />
    </div>
  );
}
